import { render, staticRenderFns } from "./YueDuShuoHua.vue?vue&type=template&id=7b129008&scoped=true"
import script from "./YueDuShuoHua.vue?vue&type=script&lang=js"
export * from "./YueDuShuoHua.vue?vue&type=script&lang=js"
import style0 from "./YueDuShuoHua.vue?vue&type=style&index=0&id=7b129008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b129008",
  null
  
)

export default component.exports